<div class="list-group-item settings-list-item">
    <div class="title-section-container flex-column gap-2">
        <b>{{mainTitle}}</b>
        <span class="text-muted lh-base" style="font-size: 0.9em;" *ngIf="subTitle">{{subTitle}}</span>
    </div>
    <div class="content-container">
        <ng-content></ng-content>
    </div>
</div>
